// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-Testimonials----testimonials-module---wrapper---30VBo src-styles----index---panel---2Guib src-styles----index---container---1O8Oe","testimonials":"src-components-Testimonials----testimonials-module---testimonials---1t5T0 src-styles----utils---deList---3vIUc","testimonial":"src-components-Testimonials----testimonials-module---testimonial---3OH4u"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Testimonials/testimonials.module.scss
// module id = 348
// module chunks = 168707334958949